import { Link } from "react-router-dom";
import { Instagram, Youtube, Twitter, Music, Facebook } from "lucide-react";

const DiscordGlyph = ({ className, style }) => (
  <svg viewBox="0 0 24 24" className={`fill-current ${className || ""}`} style={style} aria-hidden="true">
    <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3c-.2.358-.43.84-.59 1.226a18.27 18.27 0 0 0-5.487 0A12.6 12.6 0 0 0 9.882 3a19.74 19.74 0 0 0-3.76 1.369C2.692 9.07 1.79 13.65 2.24 18.166a19.93 19.93 0 0 0 6.07 3.07c.49-.67.93-1.39 1.3-2.15a12.86 12.86 0 0 1-2.05-.99c.17-.13.34-.26.5-.4a14.2 14.2 0 0 0 11.88 0c.17.14.33.27.5.4-.66.39-1.34.72-2.05.99.37.76.81 1.48 1.3 2.15a19.9 19.9 0 0 0 6.07-3.07c.53-5.25-.9-9.79-3.94-13.797ZM8.02 15.331c-1.18 0-2.157-1.08-2.157-2.41 0-1.33.96-2.41 2.157-2.41 1.2 0 2.17 1.09 2.157 2.41 0 1.33-.96 2.41-2.157 2.41Zm7.96 0c-1.18 0-2.157-1.08-2.157-2.41 0-1.33.96-2.41 2.157-2.41 1.2 0 2.17 1.09 2.157 2.41 0 1.33-.95 2.41-2.157 2.41Z" />
  </svg>
);

const SOCIALS = [
  { Icon: Instagram, url: "https://www.instagram.com/syndafam", label: "Instagram", testid: "footer-instagram" },
  { Icon: Music, url: "https://www.tiktok.com/@syndafam", label: "TikTok", testid: "footer-tiktok" },
  { Icon: Youtube, url: "https://youtube.com/@syndafam", label: "YouTube", testid: "footer-youtube" },
  { Icon: Twitter, url: "https://x.com/syndafam", label: "X / Twitter", testid: "footer-twitter" },
  { Icon: DiscordGlyph, url: "https://discord.com/invite/zbaAxtqCv", label: "Discord", testid: "footer-discord" },
  { Icon: Facebook, url: "https://www.facebook.com/syndafam", label: "Facebook", testid: "footer-facebook" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0A] mt-24" data-testid="main-footer" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <Link to="/" className="font-display text-4xl inline-block" aria-label="SyndaFam home">SYNDA<span className="text-[#E63946]">FAM</span></Link>
          <p className="text-white/50 text-sm mt-3 max-w-md">
            SyndaFam is an independent Toronto hip-hop collective sharing music, videos, artwork and creative culture from Canadian artists and creators.
          </p>
          <address className="not-italic text-white/40 text-xs mt-3 font-mono">
            Based in Toronto, Ontario, Canada · <Link to="/connect" className="hover:text-[#E63946]" data-testid="footer-contact-link">Contact SyndaFam</Link>
          </address>
        </div>
        <nav aria-label="Footer navigation">
          <div className="font-mono text-[10px] tracking-widest text-white/40 mb-3">EXPLORE</div>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/artists" className="hover:text-[#E63946]">Artists</Link>
            <Link to="/about" className="hover:text-[#E63946]">About</Link>
            <Link to="/gaming" className="hover:text-[#E63946]">Gaming</Link>
            <Link to="/gallery" className="hover:text-[#E63946]">Gallery</Link>
            <Link to="/connect" className="hover:text-[#E63946]">Connect</Link>
          </div>
        </nav>
        <div>
          <div className="font-mono text-[10px] tracking-widest text-white/40 mb-3">FOLLOW</div>
          <ul className="flex flex-wrap gap-3 list-none p-0 m-0">
            {SOCIALS.map(({ Icon, url, label, testid }) => (
              <li key={label}>
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={`SyndaFam on ${label}`}
                  title={`SyndaFam on ${label}`}
                  className="p-2 border border-white/15 hover:border-[#E63946] hover:text-[#E63946] transition-colors inline-block"
                  data-testid={testid}
                >
                  <Icon className="w-4 h-4" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center font-mono text-[10px] text-white/30 tracking-widest">
        © {new Date().getFullYear()} SYNDAFAM MUSIC GROUP · TORONTO, CANADA · ALL RIGHTS RESERVED
      </div>
    </footer>
  );
}
